<template>
	<div class="container">
		<section class="mobile_cs">
			<div class="sub_content1 d_flex justify_center align_items_center">
				<h2 class="title">
					{{ $t('cs.title') }}
				</h2>
			</div>
		</section>
		<div class="content cs">
			<p class="title">{{ $t('cs.ticket.text3') }}</p>
			<div v-if="status === 'check'" class="tac">
				<p class="mb_20 fs_14">
					{{ $t('cs.ticket.text4') }}<br />{{ $t('cs.ticket.text5') }}
				</p>
				<input
					type="text"
					class="mb_10"
					:placeholder="$t('cs.ticket.input1')"
					v-model="ticketId"
				/>
				<input
					type="password"
					class="mb_20"
					:placeholder="$t('cs.ticket.input2')"
					v-model="password"
				/>
				<button class="button_bg_red m_button" @click="createTicketToken">
					{{ $t('button.confirm') }}
				</button>
			</div>
			<div v-if="status === 'showDetail'" class="q_write complete">
				<div class="select_wrap mb_10">
					<select class="contact_type" v-model="typeSeq" disabled>
						<option value="">
							{{ $t('cs.placeholder.type') }}
						</option>
						<option
							v-for="item in ticketTypeList"
							:key="item.seq"
							:value="item.seq"
						>
							{{ item.title }}
						</option>
					</select>
				</div>

				<input type="text" class="mb_10" :value="ticketInfo?.title" readonly />

				<div class="ask">
					<div class="ask_content">{{ ticketInfo?.content }}</div>
					<div v-if="ticketInfo?.reply" class="ask_answer d_flex">
						<span>A</span>
						<p>
							{{ ticketInfo?.reply }}
						</p>
					</div>
				</div>
				<div class="inquiry_button_area">
					<button class="m_button button_bg_red" @click="initData">
						{{ $t('button.confirm') }}
					</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { createTicketToken, fetchTicket, fetchTicketTypes } from '@/api/cs';
import { commonError } from '@/common/dialog';

export default {
	name: 'InquiryDetail.m',
	data() {
		return {
			status: 'check',
			typeSeq: '',
			ticketTypeList: [],
			ticketId: '',
			password: '',
			ticketSeq: 0,
			token: '',
			ticketInfo: {},
		};
	},
	created() {
		this.init();
	},
	methods: {
		init() {
			this.loadTicketTypeList();
		},
		initData() {
			this.status = 'check';
			this.typeSeq = '';
			this.ticketId = '';
			this.password = '';
			this.token = '';
			this.ticketInfo = {};
		},
		async loadTicketTypeList() {
			const { data } = await fetchTicketTypes().catch(commonError);
			this.ticketTypeList = data.filter(item => {
				return item.allow_guest === 'Y';
			});
		},
		async createTicketToken() {
			const params = {
				ticket_id: this.ticketId,
				password: this.password,
			};
			await createTicketToken(params)
				.then(({ token }) => {
					this.token = token;
					this.loadTicket();
				})
				.catch(commonError);
		},
		async loadTicket() {
			await fetchTicket(this.ticketSeq, this.token)
				.then(({ ticket_info }) => {
					this.ticketInfo = ticket_info;
					this.typeSeq = ticket_info.type_seq;
					this.status = 'showDetail';
				})
				.catch(commonError);
		},
	},
};
</script>

<style scoped>
.m_inquiry_detail .content {
	width: 100%;
	padding: 30px 16px;
	min-height: 300px;
}
.m_inquiry_detail input {
	font-size: 14px;
	color: #333;
}
section.mobile_cs .title {
	font-size: 30px;
	line-height: 1.2;
}
.mobile_cs .sub_content1 {
	width: 100%;
	min-height: 250px;
	margin: 0 auto;
	color: #fff;
	background-size: cover;
	background: #000 url('~@/assets/images/sub/cs.png') no-repeat 43% 0;
}
.cs.content .title {
	padding-bottom: 25px;
	font-size: 24px;
	line-height: 1.2;
	font-weight: bold;
	text-align: center;
}
.cs.content p {
	line-height: 1.4;
}
.ticket_container {
	min-height: 395px;
	display: flex;
	align-items: center;
	justify-content: center;
	text-align: center;
	margin: 0 auto;
}
.q_write.complete .select_wrap select {
	background: #f0f0f0;
	color: #333;
}
.m_inquiry_detail .q_write.complete .ask {
	background-color: #f0f0f0;
	color: #333;
	font-size: 14px;
}
.q_write.complete .ask_content {
	padding-bottom: 20px;
	border-bottom: 1px solid #ddd;
}
.q_write.complete .ask_answer {
	padding-top: 10px;
	line-height: 25px;
}
.q_write.complete .ask_answer span {
	margin-right: 10px;
	display: inline-block;
	width: 25px;
	height: 25px;
	border-radius: 50%;
	background: #50be3d;
	color: #fff;
	text-align: center;
	line-height: 25px;
	font-size: 14px;
}
.m_button {
	min-width: 74px;
}
</style>
